import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { Grid } from '@mui/material'
import {
  INSURANCE_TYPE_LIST,
  POLICY_STATUS_TYPES,
  POLICY_TYPE,
  SXP_UPLOAD_POLICY_TYPE,
} from 'src/utils/constants/common'
import DigitalizingTile from 'src/components/Individual/MyPoliciesView/Tiles/DigitalizingTile'
import ReUploadTile from 'src/components/Individual/MyPoliciesView/Tiles/ReUploadTile'
import SmartBanner from 'src/components/Individual/MyPoliciesView/SmartBanner'
import {
  UploadPoliciesData,
  UploadPolicyInsuranceTypes,
} from 'src/utils/constants/MyPoliciesData'
import UploadPoliciesView from 'src/components/Individual/MyPoliciesView/Views/UploadPoliciesView'
import PolicyTile from 'src/components/Individual/MyPoliciesView/Tiles/PolicyTile'
import InsuranceDetails from 'src/components/Individual/InsuranceDetails'
import documentDownload from 'src/utils/commonMethods/documentDownload'
import { useDispatch, useSelector } from 'react-redux'
import { setInsuranceDetailsTour, setPolicyTileCardTour } from 'src/actions'
import PolicyTileCardTour from 'src/ProductTour/PolicyTileCardTour'

const PolicyDetailsView = ({
  policyList,
  openUploadPolicy,
  clientId,
  companyName,
  path,
  hideBanner = false,
  hideUploadPolicies = false,
  clientType,
  isEmployeeView = false,
  isEmployeeData,
  isCeoView,
}) => {
  const classes = useStyles()
  const [isInsuranceDetailsOpen, setIsInsuranceDetailsOpen] = useState(false)
  const [selectedPolicy, setSelectedPolicy] = useState({})
  const activeTour = useSelector(
    (state) => state?.tourReducer?.policyTileCardTour
  )
  const dispatch = useDispatch()

  const getPolicyTile = (policyData) => {
    switch (policyData?.status) {
      case POLICY_STATUS_TYPES?.digitalizing:
      case POLICY_STATUS_TYPES?.verificationPending:
      case POLICY_STATUS_TYPES?.renewalUnderDigitalizing:
        return (
          <DigitalizingTile
            policyDetails={policyData}
            handleDocumentDownload={(event) => {
              event?.stopPropagation()
              handleDocumentDownload(
                policyData?.policyDocument,
                policyData?.policyDocumentURL
              )
            }}
            handlePolicySelect={() => handlePolicySelect(policyData)}
            id='DigitalizingTile'
          />
        )
      case POLICY_STATUS_TYPES?.invalidDocument:
      case POLICY_STATUS_TYPES?.documentRequired:
        return (
          <ReUploadTile
            policyDetails={policyData}
            handleDocumentDownload={(event) => {
              event?.stopPropagation()
              handleDocumentDownload(
                policyData?.policyDocument,
                policyData?.policyDocumentURL
              )
            }}
            handlePolicySelect={() => handlePolicySelect(policyData)}
            id='ReUploadTile'
            path='dashboard/home'
          />
        )
      default:
        return (
          <PolicyTile
            id='policyTile'
            policyDetails={policyData}
            handlePolicySelect={() => handlePolicySelect(policyData)}
            companyName={companyName}
            clientType={clientType}
          />
        )
    }
  }

  const getUploadPoliciesTileData = () => {
    let uploadPoliciesTileData = [...UploadPoliciesData]

    if (
      policyList?.filter(
        (listItem) =>
          listItem?.insuranceType === INSURANCE_TYPE_LIST?.HEALTH_INSURANCE
      )?.length
    ) {
      uploadPoliciesTileData = uploadPoliciesTileData?.filter(
        (dataItem) =>
          dataItem?.insuranceType !== UploadPolicyInsuranceTypes?.health
      )
    }

    if (
      policyList?.filter(
        (listItem) =>
          listItem?.insuranceType === INSURANCE_TYPE_LIST?.MOTOR_INSURANCE &&
          listItem?.productSubType ===
            INSURANCE_TYPE_LIST?.MOTOR_FOUR_WHEELER_INSURANCE
      )?.length
    ) {
      uploadPoliciesTileData = uploadPoliciesTileData?.filter(
        (dataItem) =>
          dataItem?.insuranceType !== UploadPolicyInsuranceTypes?.car
      )
    }

    if (
      policyList?.filter(
        (listItem) =>
          listItem?.insuranceType === INSURANCE_TYPE_LIST?.MOTOR_INSURANCE &&
          listItem?.productSubType ===
            INSURANCE_TYPE_LIST?.MOTOR_TWO_WHEELER_INSURANCE
      )?.length
    ) {
      uploadPoliciesTileData = uploadPoliciesTileData?.filter(
        (dataItem) =>
          dataItem?.insuranceType !== UploadPolicyInsuranceTypes?.bike
      )
    }

    if (
      policyList?.filter(
        (listItem) =>
          listItem?.insuranceType === INSURANCE_TYPE_LIST?.LIFE_INSURANCE
      )?.length
    ) {
      uploadPoliciesTileData = uploadPoliciesTileData?.filter(
        (dataItem) =>
          dataItem?.insuranceType !== UploadPolicyInsuranceTypes?.life
      )
    }

    return uploadPoliciesTileData
  }

  const closeModal = () => {
    setIsInsuranceDetailsOpen(false)
    setSelectedPolicy({})
  }

  const handlePolicySelect = (policyDetails) => {
    if (activeTour) dispatch(setInsuranceDetailsTour(true))
    dispatch(setPolicyTileCardTour(false))
    setIsInsuranceDetailsOpen(true)
    setSelectedPolicy(policyDetails)
  }

  const handleDocumentDownload = async (document, documentURL) => {
    documentDownload(document ? document : [], documentURL)
  }

  return (
    <>
      {isInsuranceDetailsOpen ? (
        <div className={classes.insuranceDetailsContainer}>
          <InsuranceDetails
            closeFunction={closeModal}
            activePolicy={selectedPolicy}
            clientId={clientId}
            isCEO={false}
            activePolicyType={POLICY_TYPE?.PERSONAL}
            path={path}
            policyType={SXP_UPLOAD_POLICY_TYPE?.PERSONAL}
            isEmployeeView={isEmployeeView}
            isEmployeeData={isEmployeeData}
            isCeoView={isCeoView}
          />
        </div>
      ) : (
        <div className={classes.mainContainer}>
          <Grid
            container
            spacing={4}
            alignItems={'stretch'}
            justifyContent={'center'}
            paddingTop={'0px'}
          >
            {policyList?.map((policyData, index) => (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                xl={6}
                key={`policyTile_${policyData?.id}`}
                paddingTop={'2px !important'}
                marginTop={'30px'}
                paddingBottom={'5px'}
                id='policyTileCard'
              >
                {index === 0 && activeTour && <PolicyTileCardTour />}
                <>
                  {getPolicyTile(policyData)}
                  {policyData?.isCompanyPolicy ? (
                    <div className={classes.providerTextContent}>
                      <span>Provided by&nbsp;</span>
                      <span className={classes.companyText}>
                        {policyData?.companyName
                          ? policyData?.companyName
                          : policyData?.clientId}
                      </span>
                    </div>
                  ) : null}
                </>
              </Grid>
            ))}
          </Grid>

          {!hideBanner ? (
            <div className={classes.smartBanner} id='smartBanner'>
              <SmartBanner />
            </div>
          ) : null}

          {!hideUploadPolicies ? (
            <UploadPoliciesView
              uploadPoliciesList={getUploadPoliciesTileData()}
              openUploadPolicy={openUploadPolicy}
              policyType={SXP_UPLOAD_POLICY_TYPE?.PERSONAL}
              path={path}
              clientId={clientId}
            />
          ) : null}
        </div>
      )}
    </>
  )
}

export default PolicyDetailsView

const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
  },
  smartBanner: {
    display: 'flex',
    padding: '10px',
    marginTop: '16px',
  },
  modalRoot: {
    height: '90%',
  },
  insuranceDetailsContainer: {
    textAlign: 'center',
    padding: '10px',
  },
  providerTextContent: {
    fontSize: '10px',
    fontWeight: '400',
    lineHeight: '14px',
    padding: '5px',
    color: '#828282',
    marginBottom: '10px',
  },
  companyText: {
    fontWeight: '500',
    color: '#000000',
  },
})
